import BasicDateInput from "components/BasicInputs/BasicDateInput";
import Table from "components/Table";
import { indexData } from "forms";
import useDateState from "helpers/useDateState";
import DateFilterHeader from "./DateHeaderFilter";

const DateFilter = () => {


    return (
        <DateFilterHeader type="capital" />
    )
}
export default function Capital() {
    return (
        <div className="warp-capital">
            <Table type="capital" pagination={false} MidComponent={DateFilter as any} />
        </div>
    );
}
